import React, { useState } from 'react';
import { Form, Button, Spinner, Card } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';

const DocumentCreate = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type !== 'application/pdf') {
      Swal.fire('Invalid File', 'Only PDF files are allowed!', 'warning');
      e.target.value = null; // reset input
      return;
    }
    setFile(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !file) {
      Swal.fire('All fields are required!', '', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('title', title);
    formData.append('file', file);

    setLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/admin/create-document`,
        formData,
        {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      if (res.data.status) {
        await Swal.fire('Success', res.data.message, 'success');
        navigate('/admin/documents/list'); // ✅ redirect after success
      } else {
        Swal.fire('Error', res.data.message, 'error');
      }
    } catch (err) {
      globalErrorHandler(err, navigate);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-4">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">Upload New Document</h3>
        <Button variant="secondary" onClick={() => navigate('/admin/documents/list')}>
          <i className="bi bi-arrow-left me-1"></i> Back to List
        </Button>
      </div>

      <Card className="shadow">
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            {/* Document Title */}
            <Form.Group controlId="documentTitle" className="mb-3">
              <Form.Label>Document Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter document title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>

            {/* PDF File Upload */}
            <Form.Group controlId="documentFile" className="mb-3">
              <Form.Label>Upload PDF File</Form.Label>
              <Form.Control
                id="fileInput"
                type="file"
                accept="application/pdf"
                onChange={handleFileChange}
              />
            </Form.Group>

            {/* Submit Button */}
            <div className="text-end">
              <Button type="submit" variant="primary" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Uploading...
                  </>
                ) : (
                  'Save Document'
                )}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default DocumentCreate;
